import { Component, HostListener } from '@angular/core';
import { debounce } from 'lodash';
import { MenuItem } from 'src/app/core/models/system/menu-item';
import { BaseLayoutComponent } from '../base-layout/base-layout.component';


// Menu Pachage
// import MetisMenu from 'metismenujs';

@Component({
  selector: 'app-horizontal-topbar',
  templateUrl: './horizontal-topbar.component.html',
  styleUrls: ['./horizontal-topbar.component.scss']
})
export class HorizontalTopbarComponent extends BaseLayoutComponent {

  public innerWidth: any;

  @HostListener('window:resize', ['$event']) 
  onResize(event: any) { 
    this.innerWidth = window.innerWidth;
    this.onResize = debounce(this.onResize, 150, { leading: false, trailing: true, }); 
  }
  

  toggleSubItem(event: any) {
    if (event.target && event.target.nextElementSibling)
      event.target.nextElementSibling.classList.toggle("show");
  };

  toggleItem(event: any) {
    let isCurrentMenuId = event.target.closest('a.nav-link');

    let isMenu = isCurrentMenuId.nextElementSibling as any;
    let dropDowns = Array.from(document.querySelectorAll('#navbar-nav .show'));
    dropDowns.forEach((node: any) => {
      node.classList.remove('show');
    });

    (isMenu) ? isMenu.classList.add('show') : null;

    const ul = document.getElementById("navbar-nav");
    if (ul) {
      const iconItems = Array.from(ul.getElementsByTagName("a"));
      let activeIconItems = iconItems.filter((x: any) => x.classList.contains("active"));
      activeIconItems.forEach((item: any) => {
        item.setAttribute('aria-expanded', "false")
        item.classList.remove("active");
      });
    }
    if (isCurrentMenuId) {
      this.activateParentDropdown(isCurrentMenuId);
    }
  }

  haschildItems(item: MenuItem) {
    return item.childItem !== undefined ? item.childItem.length > 0 : false;
  }
  openOutwardLink(url: string|undefined){
    if(url){
      window.open(url, "_blank");
    }
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className: any) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

}
